import { useSelector } from "react-redux";

export default function useAuth() {
    const auth = useSelector(state => state.auth);

    return !!(auth?.accessToken && auth?.user);


}